module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section",
    attrs: {
      "id": "about"
    }
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "title is-2"
  }, [_vm._v("About")]), _vm._v(" "), _c('separator'), _vm._v(" "), _vm._m(1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image avatar"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/profile-2.jpg")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about-text block"
  }, [_vm._v("\n      I am Arul, FullStack Developer from Makassar.\n      "), _c('br'), _vm._v("\n      Since I was little, I was interested in computers and made things and this has led me to the world of the internet as a developer who creates all kinds of things!\n      "), _c('br'), _vm._v("\n      Currently a freelance web developer, in Jakarta. I have completed the Bachelor of Information Systems Program at STMIK Dipanegara Makassar.\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e773c7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/About.vue
// module id = 543
// module chunks = 1